import { useState, useCallback } from "react";

import debounce from "lodash/debounce";

const TIMEOUT_CONFIG = 500;

const useSearchAutoComplete = <T>(defaultValue?: T | null | undefined) => {
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [isFocus, setIsFocus] = useState(false);
  const [value, setValue] = useState<
    { label: string; value: T | null | undefined } | null | undefined
  >(
    defaultValue
      ? {
          label: String(defaultValue) || "",
          value: defaultValue,
        }
      : undefined
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSetKeyword = useCallback(
    debounce((txt: string, reason: string) => {
      if (reason === "input" || reason === "clear") {
        setKeyword(txt);
        setPage(1);
      }
    }, TIMEOUT_CONFIG),
    []
  );

  const onChange = (
    newValue: { label: string; value: T | null | undefined } | null
  ) => {
    setValue(newValue);
  };

  const onFocus = () => {
    setIsFocus(true);
    setKeyword("");
  };
  const onBlur = () => {
    setIsFocus(false);
  };

  return {
    keyword,
    value,
    isFocus,
    setIsFocus,
    onChange,
    setKeyword: debounceSetKeyword,
    onFocus,
    onBlur,
    page,
    setPage,
  };
};

export default useSearchAutoComplete;
